<div class="popup supportPopup">
    <button class="close-button" (click)="close()"></button>
    <div class="supportPopup-content">
        <div class="supportPopup-title"[i18nKey]="'support.title'"></div>
        <div class="supportPopup-content-illu"></div>
        <div class="supportPopup-linkGuide">
            <span [innerHTML]="'support.help.document' | translate:{userGuideLink: userGuideLink}"></span>
        </div>
        <div class="supportPopup-content-contact">
            <div class="contactBlock">
                <h3 class="contactBlock-title"[i18nKey]="'support.phone'"></h3>
                <a class="contactBlock-number" href="tel:+33-5-56-37-29-38">+33 (0)5 56 37 29 38</a>
            </div>

            <div class="contactBlock">
                <h3 class="contactBlock-title"[i18nKey]="'support.mail.address'"></h3>
                <a href="mailto:arkhe@arkhe.com">arkhe&#64;arkhe.com</a>
            </div>
        </div>
            <a class="arkheLink" href="http://www.arkhe.com" target="_blank">www.arkhe.com</a>
    </div>
</div>
<div class="overlay"></div>
